import { __decorate } from "tslib";
import { proxy, subscribe } from '@/infrastructure/object-reactive/object-reactive';
import { injectable } from '@/inversify.config';
let SpaceInfoModelImpl = class SpaceInfoModelImpl {
    constructor() {
        this._spaceInfo = proxy({});
    }
    get spaceInfo() {
        return this._spaceInfo.value;
    }
    updateSpaceInfo(spaceInfo) {
        this._spaceInfo.value = spaceInfo;
    }
    subscribeSpaceInfo(callback) {
        const dispose = subscribe(() => this._spaceInfo.value, (newVal) => {
            callback(newVal);
        });
        return dispose;
    }
};
SpaceInfoModelImpl = __decorate([
    injectable()
], SpaceInfoModelImpl);
export { SpaceInfoModelImpl };
